<template>
  <div>
    <Form label-position="left" :label-width="130">
      <FormItem label="姓名：">
        <span>{{basic.realname}}</span>
      </FormItem>
      <FormItem label="手机号码:">
        <span>{{basic.phone}}</span>
      </FormItem>
      <FormItem label="性别:">
        <span>{{['女','男','未知'][basic.sex]}}</span>
      </FormItem>
      <FormItem label="渠道来源：">
        <span>{{basic.sourceName}}</span>
      </FormItem>
      <FormItem label="经验值：">
        <span>{{ basic.integral }}点</span>
        <Button type="info" shape="circle" size="small" @click="adjustExperienceModal=true">调整经验值</Button>
      </FormItem>
      <FormItem label="Xdollar：">
        <span>{{basic.XDollar}}</span>
      </FormItem>
      <FormItem label="账户余额：">
        <span>￥{{basic.money?basic.money/100:0}}</span>
      </FormItem>
      <FormItem label="会员状态：">
        <span>{{['正常','锁定','黑名单'][basic.userStat-1]}}</span>
      </FormItem>
      <FormItem label="登陆密码：">
        <Button @click="resetPasswordModal=true" type="info" shape="circle" size="small">重置</Button>
      </FormItem>
      <FormItem label="验证码：">
        <span v-if="validCodeShow">{{validCode}}</span>
        <span v-else>●●●●●●</span>
        <Button @click="appear()" type="info" shape="circle" size="small">{{validCodeShow ? '隐藏' : '显示'}}</Button>
      </FormItem>
      <FormItem label="创建时间：">
        <span>{{basic.createdAt | date}}</span>
      </FormItem>
      <FormItem label="最后更新时间：">
        <span>{{basic.updatedAt | date}}</span>
      </FormItem>
      <FormItem label="最后活跃时间：">
        <span>{{basic.lastLoginDate | date}}</span>
      </FormItem>
    </Form>
    <Modal v-model="adjustExperienceModal" :loading='true' ref="adjustExperienceModal" title="调整经验值" @on-ok="preAdjustExperience">
      <Form :model="adjustExperience" :label-width="100">
        <FormItem label="增加经验值">
          <InputNumber v-model="adjustExperience.integral" :step="1"></InputNumber>
        </FormItem>
        <FormItem label="调整原因">
          <Input v-model="adjustExperience.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入调整原因"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="resetPasswordModal" :loading="true" ref="resetPasswordModal" title="重置密码" @on-ok="resetPwd">
      <Form ref="resetPwdForm" :model="resetPassword" :rules="pwdValidate" :label-width="100">
        <FormItem label="新密码" prop="pwd">
          <Input type="password" v-model="resetPassword.pwd" placeholder="请输入密码"></Input>
        </FormItem>
        <FormItem label="再次输入" prop="repeatPwd">
          <Input type="password" v-model="resetPassword.repeatPwd" placeholder="请再次输入"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Moment from 'moment'
export default {
  props:['basic','validCode'],
  data() {
    const validatePass = (rule, value, callback)=>{
      if (value === '') {
        callback(new Error('请输入密码'));
      }else if(value.length<6 || value.length>12){
        callback(new Error('密码长度为6～12位'));
      } else {
        if (this.resetPassword.repeatPwd !== '') {
          // 对第二个密码框单独验证
          this.$refs.resetPwdForm.validateField('repeatPwd');
        }
        callback();
      }
    }
    const validatePassCheck = (rule, value, callback)=>{
      if(value === '') {
        callback(new Error('请再次输入密码'));
      }else if(value !== this.resetPassword.pwd) {
        callback(new Error('两次输入的密码不一致'));
      }else{
        callback();
      }
    }
    return {
      adjustExperienceModal: false,
      resetPasswordModal: false,
      validCodeShow: false,
      adjustExperience: {
        integral:0,
        remark: ''
      },
      pwdValidate: {
        pwd: [
          {validator: validatePass, trigger: 'blur'}
        ],
        repeatPwd: [
          {validator: validatePassCheck, trigger: 'change'}
        ]
      },
      resetPassword: {
        pwd: '',
        repeatPwd: ''
      }
    };
  },
  methods: {
    appear() {
      if(!this.validCodeShow){
        this.$emit('userValidCode');
      }
      this.validCodeShow = !this.validCodeShow;
    },
    resetPwd() {
      this.$refs.resetPasswordModal.buttonLoading = false;
      this.$refs.resetPwdForm.validate((valid) => {
        if(valid){
          this.$emit('restPwd',{
            lodgerId: '',
            password: '',
            rePwd: ''
          })
          this.resetPasswordModal = false;
        }
      })
    },
    preAdjustExperience() {
      this.$refs.adjustExperienceModal.buttonLoading = false;
      if(this.adjustExperience.integral === ''){
        this.$Notice.error({
          title: '经验值不能为空'
        })
        return
      }else if(this.adjustExperience.remark.trim() === '') {
        this.$Notice.error({
          title: '备注不能为空'
        })
        return
      }
      this.$emit('editIntegral',this.adjustExperience);
      this.adjustExperienceModal = false;
    }
  },
  filters: {
    date(val) {
      if(val) {
        return Moment(val).format('YYYY-MM-DD HH:mm:ss') ;
      }
      return '';
    }
  }
};
</script>



  


// WEBPACK FOOTER //
// src/pages/vip/vip-detail/basic-info.vue